import { buildLegacyLink, buildMfeLink, LinkConfig, LinkOptions } from '@shared/utilities/routes';
import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

interface Props {
    config: LinkConfig;
    children: ReactNode;
    className?: string | ((props: { isActive: boolean }) => string | undefined) | undefined;
    options?: LinkOptions;
    onClick?: (e) => void;
}

export default function MigrationLink({ config, children, className, options, onClick }: Props) {
    if (config.shouldUseMFE) {
        return (
            <NavLink
                to={buildMfeLink(config.mfeLink, options)}
                className={className}
                aria-label={config.ariaLabel}
                onClick={onClick}>
                {children}
            </NavLink>
        );
    } else {
        return (
            <a
                href={buildLegacyLink(config.legacyLink, options)}
                className={typeof className === 'function' ? undefined : (className as string)}
                aria-label={config.ariaLabel}
                onClick={onClick}>
                {children}
            </a>
        );
    }
}
